module.exports = __webpack_public_path__ + "src/img/upload.63042ba2.svg";